import React from 'react';
import Breadcrumbs from './Breadcrumbs';
import ModernButton from './ModernButton';

interface PageLayoutProps {
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

/**
 * Layout standardisé pour toutes les pages
 * Basé sur le style du Dashboard
 */
const PageLayout: React.FC<PageLayoutProps> = ({ 
  title, 
  children, 
  actions,
  className = '' 
}) => {
  return (
    <div className={`lg:flex-1 lg:flex lg:flex-col lg:gap-6 ${className}`}>
      {/* Breadcrumbs */}
      <div className="-mt-1 mb-2 flex-shrink-0">
        <Breadcrumbs />
      </div>
      
      {/* Header */}
      <div className="mb-3 flex items-center justify-between flex-shrink-0">
        <div>
          <h1 className="text-2xl font-bold text-[rgb(var(--fg))] leading-tight">{title}</h1>
        </div>
        {actions && (
          <div className="flex gap-3">
            {actions}
          </div>
        )}
      </div>

      {/* Content */}
      <div className="lg:flex-1 lg:flex lg:flex-col space-y-5">
        {children}
      </div>
    </div>
  );
};

export default PageLayout;

